module.exports = __webpack_public_path__ + "img/attachment.8f04e12.png";